/** Money in the contract's own currency (MS-819 shared primitives, C-24),
 * replacing hardcoded "€" prefixes as the page tickets touch them (MS-820
 * cart and orders, MS-821 Excess). `currency` is `/api/v1/contract`'s ISO
 * 4217 code. Formatted with the active UI language so separators follow the
 * locale the admin picked; the symbol and its placement come from Intl.
 *
 * `fractionDigits` defaults to Intl's own for the currency (2 for EUR/USD);
 * MS-821 OQ-14 decides whether Excess shows whole units. An unknown or
 * malformed code falls back to "<amount> <code>" rather than throwing. */
export function formatMoney(
  amount: number,
  currency: string,
  options: { locale?: string; fractionDigits?: number } = {}
): string {
  const { locale, fractionDigits } = options
  const digits =
    fractionDigits === undefined
      ? {}
      : { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency, ...digits }).format(amount)
  } catch {
    return `${new Intl.NumberFormat(locale, digits).format(amount)} ${currency}`
  }
}
